import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Ornament from "./Ornament";

export default function Footer() {
  return (
    <footer
      id="contact"
      className="relative bg-[#081712] text-[#F1E9D8] px-6 md:px-10 pt-24 pb-12 overflow-hidden grain"
    >
      <div className="pointer-events-none absolute -bottom-20 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] rounded-full bg-[#D4AF6A] opacity-[0.06] blur-[140px]" />

      <div className="max-w-2xl mx-auto relative flex flex-col items-center text-center">
        <p className="font-display italic text-2xl md:text-3xl text-[#EDE6D6] mb-10 max-w-lg">
          Let's build something worth remembering.
        </p>

        <Ornament variant="divider" className="mb-10 opacity-70" />

        <div className="flex gap-5 mb-10">
          {[
            { icon: faLinkedin, href: "https://www.linkedin.com/in" },
            { icon: faGithub, href: "https://github.com/Doudi09" },
            {
              icon: faEnvelope,
              href: "https://mail.google.com/mail/?view=cm&fs=1&to=",
            },
          ].map((social, i) => (
            <a
              key={i}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="hover-glow w-11 h-11 flex items-center justify-center rounded-full border border-white/10 text-[#93A894] hover:text-[#D4AF6A] transition-colors duration-300"
            >
              <FontAwesomeIcon icon={social.icon} />
            </a>
          ))}
        </div>

        <p className="text-sm text-[#93A894]">Developed with care by Doudi</p>
      </div>
    </footer>
  );
}
